module.exports = __webpack_public_path__ + "img/info-product.555d68b2.svg";